import React from 'react'
import { Layout, Header } from '../../../../components'
import Colors from './colors'

import data from './data.json'

export default props => {
  return (
    <>
      <Header
        title={data.title}
        site={data.site}
        state="design"
        slug={data.slug + '/design/'}
      />
      <Layout
        category={data.category}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Colors />
      </Layout>
    </>
  )
}
